module.exports = __webpack_public_path__ + "img/s2P35.d35dd985.png";